import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Statistic, Table } from "antd";
import { CustomSpinner } from "../utils/CustomComponents";

const { Text } = Typography;

const FranchiseSellerMonthWeekByPsi = ({
	month,
	sellerId,
	psiId,
	psi,
	plant,
}) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [jobList, setJobList] = useState([]);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Week",
			dataIndex: "week",
			key: "week",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Yards",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
	];

	useEffect(() => {
		getJobs();
	}, []);

	const getJobs = async () => {
		try {
			setLoading(true);
			const url =
				api +
				`/job/seller/week?month=${month}&seller=${sellerId}&psiId=${psiId}&psiName=${psi}&plant=${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			const list = data.payload.map((item, index) => {
				return {
					key: index,
					yards: item.totalYards,
					week: item.week,
				};
			});

			setJobList(list);
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={jobList}
					loading={loadingTable}
					pagination={false}
				/>
			</Flex>
		);
	};

	return (
		<Flex vertical gap={"large"}>
			{loading ? <CustomSpinner /> : <RenderTable />}
		</Flex>
	);
};

export default FranchiseSellerMonthWeekByPsi;
